//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEFAULT_REPORT_IMAGES_CATEGORIES_MAP } from '../../forms/Report/Report'
import { mapGetters } from 'vuex'
import WaybillFlightPhotos from '../../forms/Waybill/WaybillFlightPhotos.vue'
import { axiosGet } from '../../axios/axios'

export default {
  components: {
    WaybillFlightPhotos
  },
  props: {
    files: {
      type: Array,
      required: true
    },
    uploadFilesFn: {
      type: Function,
      required: true
    },
    employees: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      photos: this.files,
      selectedPhotos: {},
      selectedPhotosIds: [],
      expansionCategories: {},
      reportCategories: DEFAULT_REPORT_IMAGES_CATEGORIES_MAP,
      loading: false,
      employeeFilter: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    photosFormatted: function () {
      const groups = {}
      this.files.filter(file => this.employeeFilter.includes(Number(file.userId))).forEach(file => {
        const photo = {
          url: '/service/delta/document/read?id=' + file.id,
          name: file.name,
          id: file.id,
          caption: Number(file.userId) !== this.user.employee.id ? this.formatFio(this.employees.find(employee => employee.id === Number(file.userId)).fio) : null
        }
        if (groups[file.photoCategory]) {
          groups[file.photoCategory].photos.push(photo)
        } else {
          groups[file.photoCategory] = {
            photos: [photo]
          }
        }
      })
      const result = []
      Object.keys(groups).forEach(category => {
        result.push({
          category: category,
          photos: groups[category].photos
        })
      })
      return result
    },
    employeeOptions: function () {
      const result = this.employees.map(employee => {
        return {
          label: this.user.employee.id === employee.id ? 'Мои фотографии' : this.formatFio(employee.fio),
          value: employee.id
        }
      })
      const myPhotosIndex = result.findIndex(el => el.value === this.user.employee.id)
      result.splice(0, 0, result.splice(myPhotosIndex, 1)[0])
      return result
    }
  },
  created: function () {
    this.files.map(file => file.photoCategory).forEach(category => {
      this.selectedPhotos[category] = []
    })
    this.employeeFilter = [this.user.employee.id]
    Object.keys(this.reportCategories).forEach(category => {
      this.$set(this.expansionCategories, category, true)
    })
  },
  methods: {
    formatFio: function (fio) {
      let words = fio.split(' ')
      words = words.map((w, i) => {
        if (i > 0) {
          w = w.slice(0, 1)
          w = w + '.'
        }
        return w
      })
      return words.join(' ')
    },
    loadPhotosListFromMessengers: function () {
      this.loading = true
      axiosGet({
        url: 'service/delta/employee/getMessengerPhotos?employeeId=' + (this.user.employee ? this.user.employee.id : this.user.systemUser.properties.$id) + '&reportId=',
        onSuccess: (response) => {
          this.photos = response.data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onSelectPhoto: function (value, category) {
      this.selectedPhotos[category] = value
      this.selectedPhotosIds = []
      Object.values(this.selectedPhotos).forEach(value => {
        this.selectedPhotosIds.push(...value)
      })
    },
    onUpload: function () {
      this.loading = true
      this.uploadFilesFn(this.selectedPhotos).then((result) => {
        this.$emit('upload')
      }).finally(() => {
        this.loading = false
      })
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}
